import React from 'react';
import PropTypes from 'prop-types';

import {Box, Stack, Typography} from 'views/components';
import {AttachMoneyOutlined} from 'views/icons';
import {Translate} from 'views/module';

import CardPaper from './CardPaper';

const PayAndHoursCard = (props) => {
  const {jobDataParsed} = props;

  return (
    <CardPaper>
      <Stack direction="row" spacing={1} alignItems="center" sx={{mb: 1}}>
        <AttachMoneyOutlined fontSize="small" />
        <Typography variant="body2" sx={{fontWeight: 700}}>
          <Translate expression='jobDetail.PayAndHours.Title' />
        </Typography>
      </Stack>

      <Stack direction="row" justifyContent="space-between" alignItems="flex-start" sx={{mb: 1.25}}>
        <Box>
          <Typography variant="body1" sx={{fontWeight: 800}}>
            {jobDataParsed.payPerHour}
          </Typography>
          <Typography variant="caption" sx={{color: 'text.secondary'}}>
            <Translate expression='jobDetail.PayAndHours.HourlyRate' />
          </Typography>
        </Box>

        <Box sx={{textAlign: 'right'}}>
          <Typography variant="body1" sx={{fontWeight: 800}}>
            {jobDataParsed.payPerWeekString}
          </Typography>
          <Typography variant="caption" sx={{color: 'text.secondary'}}>
            <Translate expression='jobDetail.PayAndHours.PerWeek' />
          </Typography>
        </Box>
      </Stack>

      <Box
        sx={{
          borderRadius: 2,
          px: 1.5,
          py: 1,
          bgcolor: 'rgba(46, 125, 50, 0.10)',
          border: '1px solid rgba(46, 125, 50, 0.18)',
        }}
      >
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography variant="caption" sx={{fontWeight: 700, color: 'rgba(46, 125, 50, 0.95)'}}>
            <Translate expression='jobDetail.PayAndHours.EstimatedEarnings' />
          </Typography>
          <Typography variant="caption" sx={{color: 'rgba(46, 125, 50, 0.85)'}}>
            {jobDataParsed.summaryLabel}
          </Typography>
        </Stack>
      </Box>
    </CardPaper>
  );
};

PayAndHoursCard.propTypes = {
  jobDataParsed: PropTypes.object.isRequired,
};

export default PayAndHoursCard;
